import BaseModalController from 'components/modal/js/controller/base-modal-controller';

export class SchoolsModalController extends BaseModalController {
    constructor($mdDialog) {
        super($mdDialog);
    }
}

SchoolsModalController.$inject = [
    '$mdDialog',
];
